import { Injectable, Pipe, PipeTransform } from '@angular/core';
import {
    SnapshotImageContract,
    SnapshotMapType,
} from '@polaris-customerweb/sharedcomponents.core';
import { isArray } from 'lodash-es';
import { SnapshotService } from '../services/snapshot.service';

@Injectable({
    providedIn: 'root',
})
@Pipe({
    name: 'snapshotToUrl',
    standalone: true,
})
export class SnapshotToUrlPipe implements PipeTransform {
    constructor(private snapshotService: SnapshotService) {}

    transform(
        snapshots: readonly SnapshotImageContract[],
        sizes: string | string[],
        type?: string
    ) {
        if (!isArray(snapshots)) {
            return '';
        }

        if (typeof sizes === 'string') {
            sizes = [sizes];
        }

        if (!isArray(sizes)) {
            return '';
        }

        return this.snapshotService.getSnapshotUrl(
            snapshots,
            sizes,
            type as SnapshotMapType
        );
    }
}
